import { clone } from 'isomorphic-git'
import FS from '@isomorphic-git/lightning-fs'
import http from 'isomorphic-git/http/web'
import { Buffer } from 'buffer'
import * as process from 'process'

window.global = window
window.process = process
window.Buffer = Buffer

const STRIP_BEGINNING_AND_END_SLASHES = /^\/|\/$/g
const MAX_ATTEMPTS = 3
const RETRY_DELAY_MS = 2000

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

class Git {
  constructor (options) {
    this.options = options
    this.modes = ['read']
    this.fsName = options.url.replace(/[^\w]/g, '-')
  }

  get name () {
    return `Git (${this.options.url.replace(STRIP_BEGINNING_AND_END_SLASHES, '')}${this.options.filename})`
  }

  async fetch () {
    const dir = '/data'
    const filename = this.options.filename.replace(STRIP_BEGINNING_AND_END_SLASHES, '')

    let lastError
    for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
      const fs = new FS(this.fsName, { wipe: true })
      try {
        await clone({
          fs,
          http,
          dir,
          ref: this.options.branch,
          url: this.options.url.replace(STRIP_BEGINNING_AND_END_SLASHES, ''),
          corsProxy: 'https://git-cors.dallasread.com',
          singleBranch: true,
          depth: 1,
          onAuth: (url) => {
            if (!this.options.username) return {}

            return {
              username: this.options.username,
              password: this.options.password
            }
          }
        })
        const content = await fs.promises.readFile([dir, filename].join('/'))
        return content.toString()
      } catch (error) {
        lastError = error
        if (attempt < MAX_ATTEMPTS) await wait(RETRY_DELAY_MS * attempt)
      }
    }
    throw lastError
  }
}

export default Git
